import React from 'react';

import { DxIcon } from '@atlaskit/logo';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => <LogoTable icon={<DxIcon appearance="brand" />} />;
